import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { useTheme } from '@mui/material';

export type PropsTypeHZStepper = {
    steps: string[];
    activeStep: number;
    setActiveStep?: (step: number) => void
}

export default function HorizontalLinearStepper({ steps, activeStep, setActiveStep }: PropsTypeHZStepper) {

    // const isStepOptional = (step: number) => {
    //     return step === 1;
    // };

    // const handleNext = () => {
    //     setActiveStep(activeStep + 1);
    // };

    // const handleBack = () => {
    //     setActiveStep(activeStep - 1);
    // };

    // const handleReset = () => {
    //     setActiveStep(0);
    // };
    const theme = useTheme()
    return (
        <Box sx={{ width: '100%' }} mb='20px'>
            <Stepper sx={{
                '& .Mui-active circle': { color: theme.palette.primary.main },
                '& .Mui-completed path': { color: theme.palette.primary.main },
                '& svg': { fontSize: '28px' },
                '& .MuiStepConnector-root': { flex: 0, width: '38px' },
                '& .MuiStepConnector-line': { width: '38px' },
                justifyContent: 'center',
                '& .Mui-disabled circle': { color: theme.palette.background.input },
            }} activeStep={activeStep}>
                {steps.map((label, index) => {
                    const stepProps: { completed?: boolean } = {};
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel sx={{
                                '& span': {
                                    fontWeight: '400 !important',
                                    fontSize: '14px',
                                    lineHeight: '21px',
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    );
}
